export default {
    header: "Órdenes de {name}",
    error: "Se produjo un error",
    empty: "No se encontraron pedidos",
    system: "Mesa de ayuda",
    orders: {
        name: "Nombre",
        date: "Fecha",
        status: "Estado",
        approvedBy: "Aprobado por"
    },
    cta: {
        close: "Cerca"
    }
}